import { useDelete, UseDeleteParams } from '../../../../api';
import { useCallback } from 'react';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';

type DeleteApplicationParams = UseDeleteParams<{ id: string }, { error: string }>;

export const useDeleteApplication = (deleteParams: DeleteApplicationParams) => {
    const { deleteMethod, loading } = useDelete<{ id: string }, { error: string }>(deleteParams);

    const deleteApplication = useCallback(
        (id: string) => deleteMethod(`${ACCESS_ANALYSIS_BASE_URL}/applications/${id}`),
        [deleteMethod]
    );

    return {
        deleteApplication,
        deleteApplicationLoading: loading
    };
};
